import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import { optimizedApiUrl } from "../../config/api";
import "./admin_api_management.css";

function isEnabled(api) {
  return Boolean(api.Active) && String(api.Status || "").toUpperCase() === "ACTIVE";
}

function AdminApiManagement(props) {
  const [apis, setApis] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState("");
  const [error, setError] = useState("");

  const totals = useMemo(() => {
    return apis.reduce(
      (acc, api) => {
        acc.total += 1;
        if (isEnabled(api)) acc.active += 1;
        else acc.inactive += 1;
        return acc;
      },
      { total: 0, active: 0, inactive: 0 },
    );
  }, [apis]);

  const loadApis = () => {
    setLoading(true);
    setError("");
    axios
      .post(optimizedApiUrl("/admin/api-management"), {
        clientId: props.clientId,
        action: "list-production-apis",
        search,
      })
      .then((res) => {
        if (!res.data?.success) {
          setApis([]);
          setError(res.data?.errorMessage || "No se pudieron cargar las APIs.");
          return;
        }
        setApis(res.data.apis || []);
      })
      .catch((err) => {
        setApis([]);
        setError(err?.response?.data?.errorMessage || "No se pudieron cargar las APIs.");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadApis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleApi = (api) => {
    const nextActive = !isEnabled(api);
    const action = nextActive ? "activar" : "desactivar";
    if (!window.confirm(`Confirmar ${action} ${api.Name} en produccion?`)) return;
    setSavingId(api.ApiId);
    setError("");
    axios
      .post(optimizedApiUrl("/admin/api-management"), {
        clientId: props.clientId,
        action: "production-status",
        apiId: api.ApiId,
        active: nextActive,
      })
      .then((res) => {
        if (!res.data?.success) {
          setError(res.data?.errorMessage || "No se pudo actualizar la API.");
          return;
        }
        loadApis();
      })
      .catch((err) => setError(err?.response?.data?.errorMessage || "No se pudo actualizar la API."))
      .finally(() => setSavingId(""));
  };

  return (
    <div className="admin_api_management_prod">
      <div className="api_mgmt_prod_header">
        <div>
          <h2>API Status</h2>
          <p>Activar y desactivar APIs de produccion.</p>
        </div>
        <button className="btn btn_primary" onClick={loadApis} disabled={loading}>
          Actualizar
        </button>
      </div>

      <div className="api_mgmt_prod_summary">
        <div><span>Total</span><strong>{totals.total}</strong></div>
        <div><span>Activas</span><strong>{totals.active}</strong></div>
        <div><span>Desactivadas</span><strong>{totals.inactive}</strong></div>
      </div>

      <div className="api_mgmt_prod_toolbar">
        <input
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") loadApis();
          }}
          placeholder="Buscar API"
        />
        <button className="btn btn_glass" onClick={loadApis} disabled={loading}>
          Buscar
        </button>
      </div>

      {error && <div className="api_mgmt_prod_error">{error}</div>}
      {loading ? (
        <div className="api_mgmt_prod_empty">Cargando APIs...</div>
      ) : (
        <div className="api_mgmt_prod_list">
          {apis.map((api) => {
            const active = isEnabled(api);
            return (
              <div className="api_mgmt_prod_row" key={api.ApiId}>
                <div>
                  <h3>{api.Name}</h3>
                  <p>{api.Description || "Sin descripcion."}</p>
                  <span>{api.SupplierName || "Sin proveedor"} - {api.ActiveEndpointCount}/{api.EndpointCount} endpoints activos</span>
                </div>
                <div className="api_mgmt_prod_row_actions">
                  <strong className={active ? "active" : "inactive"}>{active ? "Activa" : "Desactivada"}</strong>
                  <button className="btn btn_primary" onClick={() => toggleApi(api)} disabled={savingId === api.ApiId}>
                    {savingId === api.ApiId ? "Guardando..." : active ? "Desactivar" : "Activar"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AdminApiManagement;
